<template>
  <el-button :type="type" @click="toClick" :round="round" :size="size" :style="{background: background, color: color}">
    <slot v-if="!text"></slot>
    {{ text  }}
  </el-button>
</template>

<script>
export default {
  name: 'common-btn',
  props: ['text', 'type', 'background', 'color', 'size', 'round'],
  methods: {
    toClick() {
      this.$emit('toClick')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commonBtn.vue